import { z } from "zod";
/**
 * Error codes returned by the API. Each maps to one HTTP status and one problem type.
 * The web app uses `code` to decide what to show; `requestId` lets support find the logs.
 */
export const PROBLEM_CODES = [
    "bad_request",
    "validation_failed",
    "unauthenticated",
    "permission_denied",
    "password_change_required",
    "not_found",
    "conflict",
    "precondition_failed",
    "rate_limited",
    "dependency_unavailable",
    "internal_error",
];
export const ProblemCodeSchema = z.enum(PROBLEM_CODES);
export const FieldErrorSchema = z.object({
    path: z.string(),
    message: z.string(),
});
/** RFC 9457 "problem details" body used for every error response. */
export const ProblemDetailsSchema = z.object({
    type: z.string(),
    title: z.string(),
    status: z.number().int(),
    code: ProblemCodeSchema,
    detail: z.string().optional(),
    instance: z.string().optional(),
    requestId: z.string().optional(),
    errors: z.array(FieldErrorSchema).optional(),
});
export const problemTypeFor = (code) => `urn:pokifolio:problem:${code.replaceAll("_", "-")}`;
//# sourceMappingURL=problem.js.map